import {GroupToken, iAdmin, storageAuthInformation, storageAuthRefreshToken, storageAuthToken, storageRoles,
  XSRFToken
} from '../constants/strings';

export interface AuthDto {
  isAuthenticated: boolean,
  isAdmin: boolean,
  authToken: string,
  refreshToken: string,
  roles: string[],
  fullName: string,
  userId: string
}

export const authInit: AuthDto = { isAuthenticated: false, isAdmin: false, authToken: '', refreshToken: '', roles: [], fullName: '', userId: '' };

export const isUserAuthenticated = (): boolean => {
  const tokenValue = getToken();
  return !(tokenValue.length === 0);
}

export const getToken = (): string => {
  const adminToken = sessionStorage.getItem(storageAuthToken) ?? ""
  const groupToken = sessionStorage.getItem(GroupToken) ?? ""
  let authToken = "";
  if(adminToken !== "") authToken = adminToken
  else if(groupToken !== "") authToken = groupToken

  return authToken;
};
export const getXSRFToken = (): string => sessionStorage.getItem(XSRFToken) ?? "";
export const getRefreshToken = (): string => sessionStorage.getItem(storageAuthRefreshToken) ?? '';
export const getUserId = (): string => authInfo().userId;


export const isAdmin = (): boolean => {
  return roles().findIndex((item: string) => { return item === iAdmin; }) > -1;
}

export const getFullName = (): string => {
  let auth = authInfo();
  return auth.fullName;
}
const roles = (): string[] => {
  return JSON.parse(sessionStorage.getItem(storageRoles) ?? JSON.stringify([]));
}

const authInfo = (): AuthDto => {
  return JSON.parse(sessionStorage.getItem(storageAuthInformation) ?? JSON.stringify(authInit)) as AuthDto;
}
